import { combineReducers } from 'redux';
import menulist from './menulist.js';
import titlelist from './titlelist.js';
import tenetlist from './tenetlist.js';
import videolist from './videolist.js';
import sodtoday from './sodtoday.js';
import industry from './industry.js';
import indproduct from './indproduct.js';
import product from './product.js';
import teamlist from './teamlist.js';
import advertlist from './advertlist.js';
import buisnesslist from './buisnesslist.js';
import liclist from './liclist.js';
import presentationlist from './presentationlist.js';
import leftmenulist from './leftmenulist.js';
import sectioncontent from './sectioncontent.js';
import contactlist from './contactlist.js';
import predmenu from './predmenu.js';
import compcontent from './compcontent.js';
import titleprice from  './titleprice.js';
import { routerReducer as routing } from 'react-router-redux';

export default combineReducers({
  routing,
  menulist,
  titlelist,
  tenetlist,
  videolist,
  sodtoday,
  industry,
  indproduct,
  product,
  teamlist,
  advertlist,
  buisnesslist,
  liclist,
  presentationlist,
  leftmenulist,
  sectioncontent,
  contactlist,
  predmenu,
  compcontent,
  titleprice
});



// WEBPACK FOOTER //
// ./src/client/reducers/index.js